import { observable, action } from 'mobx';
import _ from 'lodash';

class CreateCourseStore {
  @observable course = _.assign({}, {
    title: '',
    description: '',
    on_site_date: null,
    off_site_date: null,
    price: 160
  });

  @observable errors = {};

  @action
  initNewCourse = () => {
    this.course = {
      title: '',
      description: '',
      on_site_date: null,
      off_site_date: null,
      price: 160
    }
  }

  @action
  setCourse = course => {
    this.course = course;
  }

  @action
  setError = errors => {
    this.errors = errors;
  }

  @action
  handleChange = data => {
    _.assign(this.course, data);
  }

  @action
  handleDate = date => {
    _.assign(this.course, date);
  }
}

export default new CreateCourseStore();



// WEBPACK FOOTER //
// ./src/stores/CreateCourseStore.js